import { telaSobDemanda, type TelaRotina } from '../tipoTelaRotina';

export const telasFIN: Record<string, TelaRotina> = {
  'fin/fechamento': telaSobDemanda(() => import('../../../modulos/FIN/PaginaFechamento'), 'PaginaFechamento'),
  'fin/posicao-titulos': telaSobDemanda(() => import('../../../modulos/FIN/PaginaPosicaoTitulos'), 'PaginaPosicaoTitulos'),
  'fin/fluxo-caixa': telaSobDemanda(() => import('../../../modulos/FIN/PaginaFluxoCaixa'), 'PaginaFluxoCaixa'),
  'fin/conciliacao': telaSobDemanda(() => import('../../../modulos/FIN/PaginaConciliacao'), 'PaginaConciliacao'),
  'fin/renegociacao': telaSobDemanda(() => import('../../../modulos/FIN/PaginaRenegociacao'), 'PaginaRenegociacao'),
  'fin/adiantamentos': telaSobDemanda(() => import('../../../modulos/FIN/PaginaAdiantamentos'), 'PaginaAdiantamentos'),
  'fin/painel': telaSobDemanda(() => import('../../../modulos/FIN/PaginaPainel'), 'PaginaPainel'),
  'fin/recalculo-saldos': telaSobDemanda(() => import('../../../modulos/FIN/PaginaRecalculoSaldos'), 'PaginaRecalculoSaldos'),
};
